import Skeleton from "@mui/material/Skeleton";

interface GhostProps {
  height?: number | string;
  className?: string;
}

const Ghost = ({ height = 200, className }: GhostProps) => {
  return (
    <Skeleton
      variant="rounded"
      width="100%"
      animation="pulse"
      height={height}
      className={className}
    />
  );
};

export default Ghost;
